module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/004TOC#chapter_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Suzanne")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Suzanne had just got back from court Thursday and was running a bath when Elena walked in, yelling from the living room, “Mother? Mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You startled me!” Suzanne cried, hastily pulling on her terry robe. She shut off the water. “Why didn’t you call?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know you’re never here, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here I am right now. Besides, what are answering machines for?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I always thought it was so you could stand and listen and decide if somebody was worth your attention, before you’d pick up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne drew a deep breath. Be calm, be calm. She felt rising in herself the particular sharp anxiety tinged with fear she always felt when she had not seen her elder daughter for a while. “I’ll be right with you.” She rushed into her bedroom to throw on slacks and a sweater. Suzanne was systematic, orderly. She made a joke of it. “I’m the only daughter of an organizer, and wow, am I organized.” She called before going to a friend’s house (except for Marta upstairs), made appointments with everybody including her daughters. She had a daily calendar of activities, appointments, and projects from the mundane (take suit to cleaners; put recycled goods at curb) to the important (work on speech for Harvard women’s law alumnae meeting). She reminded herself in advance to buy presents for her children and her friends, all of whose sizes were kept up-to-date on her computer. Six months in advance, she made appointments with the dentist to have her teeth cleaned, and every November she arranged for Marta and herself to go and have their annual mam"), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("mograms in January. Marta’s mother had died of breast cancer, so Marta could never bring herself to make the phone call.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne realized this habit of meticulously planned days must irritate her older daughter, for Elena had certainly chosen to go to the other extreme, exalting spontaneity. Elena would never say, “I am coming to dinner next Friday,” but would always hedge her bets. “I think I can make it, but I’ll let you know.” It was the adolescent hope that something more exciting than dinner with Mama would turn up, a belief that there were always other possibilities that might unfold before Friday. She understood, but nonetheless, it hurt her feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne rushed into the living room. “You’re looking good. Is everything okay, sweetheart?” It was impossible to tell from Elena’s appearance if she were doing well or poorly, for she always looked lovely. Often it startled Suzanne that she had given birth to such a beauty. Elena had her father Victor’s coloring, black hair and instead of Suzanne’s nearsighted green eyes, she had large, large dark brown eyes, doe eyes, dramatic and appealing. She was a good five inches taller than Suzanne (Victor, the Guatemalan politico, had been six feet two). Her skin was olive like her father’s, and her mouth was full and sensual. Nobody ever missed Elena in a crowd. She had a dramatic voice too, in a lower register; Suzanne herself was an alto rather than a soprano. She had often been told her voice led people to expect a bigger woman. Petite Suzanne and her statuesque daughter stood in the living room a bit squared off as always. Suzanne could not help the nails of worry that pounded into her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So how’s the good daughter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I assume you mean your sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who else would I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s working hard at school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s always working hard. Even when she’s asleep, she’s working hard. That’s how good daughters are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Elena, did you come all the way over here to pick a fight with me about your sister? Please tell me what’s up. Please.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Elena threw herself down on the couch. She was wearing a tight short leather skirt that rode up. Suzanne had to control herself not to point that out. She had learned a few things over the years, one of which was ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("never, never to comment on Elena’s clothing or any new body piercings or tattoos she noticed. Various earrings in both ears and her nose stud, but she didn’t observe any new mutilations. She was relieved. Her daughter’s body was so beautiful, and she was always devising what seemed to Suzanne new punishments for it.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have a beer? Cold?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe, I’m not sure.” Beer was not something she regularly stocked in the winter. “Wouldn’t you like something to eat? I haven’t eaten yet myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d rather have beer on an empty stomach. Then I’ll eat a big meal and go swimming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Elena, is something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course not. What could be wrong with me, except for my existence? I’m sure you’re going to say I told you so.” Elena grimaced and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Told you so about what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That it wouldn’t work out living with Jennifer. So now she’s moved out on me and I’m getting evicted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Evicted, why? Do you need money for rent?” She was ready to write a check.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What use is that? It’s too late. They’re throwing me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But why didn’t you pay your rent?” Suzanne had the familiar sense of being drawn deeper and deeper into a bottomless bog. “Don’t you make enough at that restaurant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That bitch fired me, that’s why.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think she does anything that makes sense? She felt like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you’ve been fired without cause, I think you have a case.” Suzanne had a hopeful moment: she could be useful to her daughter. She even imagined Elena’s gratitude if she won a case for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, Mother, don’t be such a lawyer prick. I slapped a customer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh…I’m sure you had good reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So I’m going to be out on the street next Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne was silent for a moment. Then she said what she had to. “Of course you can move back in. We can rearrange the rooms—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("“Don’t act so martyred. I promise I won’t stay long. I wouldn’t move back here if everything wasn’t so fucked up right now.” Elena unfolded ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("herself from the couch and paced to the fireplace and back. “Could we have a fire?”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s have supper first. I’ll check about the beer.” Her evening was coming to pieces. She thawed a soup in the microwave. She would pull a couple of baguettes from the freezer and stick them in the oven. While the lamb barley soup heated, she washed greens and put together a salad. With a lot of work sketched out in her head, she had looked forward to collapsing on her comfortable leather couch, her feet in furry slippers up on the padded armrest and her papers for Sherry, the sexually harassed policewoman, on her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Far from suffering from the empty-nest syndrome her friends had warned her about in tones usually reserved for commiserating about a root canal, Suzanne had flourished. She had expanded deliberately and joyously to fill the apartment, to fill her life. She even had a little time to play now and then on the Internet, to read a novel, to listen to music. She loved living alone, absolutely loved it. She felt so marvelously irresponsible in small details, not judged, not tested, not pushed or resented. She had become used to doing as she pleased with her own space and her free time, such as it was. Now Elena would expect to be taken care of and resent every single thing her mother did for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had raised her daughters pretty much on her own since Elena was twelve and Rachel was seven, and before that, for Elena’s first five years. She had not been a particularly good mother, too busy, too interested in her own work, too demanding. She could hear Elena talking to Sherlock in the living room. “Sherlock, you’re so sleepy. What a sleeping Sherlock. That’s right, blink. Roll on your back and I’ll rub your wonderful striped tiger tummy…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Why couldn’t Elena ever address her with half that affection? Suzanne wondered—putting it on the agenda to bring up with Marta—if she was not a deeply irritating person, infuriating. Suzanne had always had good tight women friends, but she had also frequently annoyed many other women. They seemed to find her hard, uppity, lacking in the middle class kissy-face social graces. She never made much small talk or gave polite compliments. She was a good litigator, a good hired or pro bono gun, but a crappy hostess. Unfortunately, one of the women she most annoyed was her own daughter. Calm down, she said to herself, at least this time the problem is just money and a job. No drugs, no unsuitable ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("men, Elena isn’t pregnant or in trouble with the law. She should be relieved, but her anxiety remained. When Elena was fifteen, Suzanne discovered how well her daughter could lie to her, and she had never quite recovered from that shock. The doubt always quivered there, was she being fooled, was she fooling herself about Elena?")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Over supper, she thought aloud. “So you need to move in probably over this weekend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not working, so one day is like another.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not to me,” Suzanne said, then softened her voice. “So we should get my gym equipment out of the old playroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am not going to sleep in that room off the kitchen. You’d wake me every damned morning at six. No thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right, you can use Rachel’s room. She isn’t about to come home until spring break at the earliest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want Rachel’s room. I want mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne took a deep breath. “Elena, that’s fixed up as my office. It has been for six years. I have no place else to put my files, my computer—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have an office at school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t keep my case work there. It isn’t secure and the university doesn’t approve of law school faculty conducting private practice on the premises. I have to work at home and I can’t move six years of accumulation out of my office.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It was supposed to be my room.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Elena, you moved out with great fanfare six years ago. Did you want me to keep it as a shrine?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena laughed. “With candles burning day and night and incense and flowers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Incense makes me sneeze,” Suzanne said reasonably. “I can go buy some flowers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s only for a month or so till I get another job. Rachel can stay in that stupid room off the kitchen. I’m sure she gets up at six every morning and thanks God he didn’t make her me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In some ways, your sister has always admired you. Sometimes she envied you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena grimaced. “Because she has no idea how to talk to men.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Because Rachel looked like Suzanne except for lighter hair. She re")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("membered Rachel crying in high school, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My life would be so different if I were beautiful like her, my life would be much better")]), _vm._v(". Suzanne had a brief impulse to tell Elena about Jake and his plan to appear in the flesh. Once she had almost told Rachel when they were chatting about the Internet, but on reflection, she had not considered it becoming to inform her daughters that she had a long and intense flirtation going with a man she had never met, and was now terrified to meet: an environmental activist dogged by the FBI who wrote her an ecstatic two-page E-mail about butterflies in Costa Rica. This man who had lain down in front of bulldozers had sent her a perfect little carved seal from the Inuit and another time a salmon smoked till it resembled a piece of wood. This man had taken a ship into a nuclear test zone, and now was threatening to invade her own territorial waters.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena rose, stretched gracefully as a panther, and sauntered to Rachel’s room. She stood in the doorway, shaking her head. “I’m going to have to change things around. I can’t sleep in here, the way it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no use in her arguing that the arrangement was supposed to be temporary. If Elena announced she could not sleep, she would not sleep. Rachel was going to get a lot of practice being forgiving. Elena was back, and maybe they could learn to talk to each other instead of always fencing, and heal some of their old scars. Maybe. Suzanne the top-notch negotiator always seemed to falter when she went head-to-head with her older daughter; Suzanne the litigator always lost her case when she was arguing points with Elena. Somehow she had to find a mode of communication between them that actually communicated. Once, years and years ago when Elena was a child, they had had intense intimacy. Elena had been her precious miracle, with her father who had disappeared into mythology leaving her a child beautiful as an orchid and strong as a tiger cub. Elena’s childish paintings had been lush, vivid, unlike the scrawls of other more ordinary kindergarten finger-painters. Elena had danced as early as she walked. How affectionate she had been then, flinging herself into her mother’s arms when Suzanne walked into a room. And how radically it all changed when Elena passed puberty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Elena, if we try, maybe we can make this work. Get along better with each other,” she said softly, trying not to put too much force into the words lest they seem a demand.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s just for a while, like a month, six weeks,” Elena said. “We don’t have to get in each other’s way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want us to do better than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Rather than intense preparation for her sexual harassment case, most of Suzanne’s weekend was spent moving Rachel’s things into temporary storage along one wall of the room she was still using as her gym and helping Elena move into Rachel’s room. A lot of Elena’s possessions and off-season clothes went into the basement, crowded before Elena’s stuff was shoved in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On Saturday they had the help of a gangling orange-haired young man Elena knew from her former restaurant job. He was a sous-chef there, making salads and arranging food on plates. He was clearly smitten, but Elena was uninterested. “A big baby,” she said. “Sex appeal of a cooked shrimp.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sunday’s help came in the form of a man perhaps fifteen years older than Elena. He was of distinctly less use than the boy had been, puffing on the stairs. He complained of his back and wanted to argue about where things should be put. Elena and he disappeared into her room for an hour in the middle of the afternoon. What could Suzanne possibly say? It made her uncomfortable to think of her daughter in bed with that oily creep, but she knew she had to keep her reaction to herself. Elena had been sexually active since puberty, and there never had been anything Suzanne could do about it. It did not help her mood that she had not made love to anyone in twelve years. She turned on the stereo and did her laundry in the basement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is he your current…” Suzanne fumbled for the word. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boyfriend")]), _vm._v(" seemed absurd for a forty-plus-year-old man, but she could think of nothing else. “…your current boyfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I see him too, Suzanne thought, and I don’t much like what I see. “What does he do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s all you ever ask about someone, isn’t it? Peg them. The next question is, where did they go to school?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne waited. She was better at silence than her daughter. Finally Elena burst out, “He sells swimming pools. As if that defined who he is!”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Divorced?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Twice. Satisfied?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena relented slightly. “Anyhow, he’s on his way out,” she said. “Doesn’t he complain all the time, a drone like Muzak in elevators? He’s boring. Like most of your generation, he whines.” Elena shook out her hair, weighing it in her hands. “Want a swimming pool? I can get you a deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Swimming is not my exercise. Nor his, I imagine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena snorted. “The only exercise he likes requires a partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suzanne was grateful to the outgoing pool salesman nonetheless, because when Elena was displeased with somebody else, she was friendlier to her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They settled in gingerly. Elena was wooing the cats. Sherlock had succumbed to her at once, but Tamar belonged only to Suzanne and would not let Elena touch her. She had found them on the street, abandoned kittens of no more than seven weeks, flea-bitten, with worms of three kinds and a respiratory infection. Now they were huge and beautiful, Sherlock lean and muscular, with clearly Oriental head shape, a long nose (like hers). She considered his profile aristocratic. If she held him up extended across the doorway, his body stretched from doorjamb to doorjamb. Tamar was apricot rather than reddish and fluffier. Her eyes were huge and round, giving her a perennially astonished expression. She was as big as her brother but softer bodied. She had an enormous purr only for Suzanne. She slept pressed against Suzanne’s side and would have liked to keep her mistress on a leash. Both cats shared tiny squeaky voices, a remnant of their starving kittenhood and ludicrous in such large gorgeous cats.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena could not help being seductive with the cats, as with half the world. It was her way of wanting to be liked, Suzanne told herself. Jake and she had been chatting again about everything in their lives. She had told Jake all about Elena—well, a little about Elena would be more accurate.")])]), _c('div', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elena got into a mess with two boys when she was fifteen. Fortunately this whole tragedy happened around the time that law schools were briefly searching for “qualified” women to hire, to keep their ")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("governmental funds. I had been serving as adjunct faculty with the university law clinic. So finally I was offered a full tenure-track faculty position, and I took it so that I would have more time home.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Understand, being a law professor is kind of cushy. The way the tenured faculty complain about the students and facilities, you’d never know it, but actually it’s far more relaxing. You don’t make the huge bucks, but it’s prestigious and you have plenty of time to take cases you want to take on the side, increasing your visibility, reputation, and sometimes making lots of money if it’s that kind of case. Since I was absolutely riddled with guilt about Elena, the offer no matter how crassly motivated came at a time I needed to regroup. And I’ve been teaching there ever since")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I appreciate that you haven’t asked me exactly what happened to Elena. I think that even today, I couldn’t write it down. I’ve never been able to come to terms with it, I know that. Someday I will, and then I’ll tell you the whole story")]), _vm._v(".")])])])]), _c('div', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I envy you knowing your daughter so well. I lost custody years and years ago, and so I rarely see Leaf, and never alone. She’s twenty-five and married already. She works in an insurance office in Boise. My last photo of her is from her wedding. I haven’t lived with her since she was five and my wife left me. I was a quintessential hippie then. I worked in a head shop, I was an orderly in a hospital, I sold hot dogs at the beach, I was a messenger. My wife just got sick of a life on the edge of nothing in particular and went home to her parents in Idaho. She got a divorce with a judge who considered me a menace to society because my hair was shoulder length and I smoked dope. I think off the record he also considered me a dirty Jew who had no business with a blond and lovely daughter of Idaho. He kept calling me a New Yorker, although I grew up in Worcester.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Even after I cleaned up and finished school, she—my ex-wife Patsy—had no use for me. She never believed I’d changed. Whatever I said to her, she had this Oh Yeah look in her eyes, sort of squinted, letting me talk but never listening.")])])]), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Patsy was crazy about me when we were first together, but after ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("our daughter, Leaf, was born, she began to judge me and our life. I should have caught on but I was so comfortable doing whatever I felt like when I felt like it, a perennial adolescent all through my twenties, that I just never saw what was happening. I was so used to Patsy adoring me, so used to being adored, that I never noticed how pissed off she was until she took off and left me.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Suzanne read the message that night in her office while Elena was moving stuff around in the next room. Suzanne was exhausted and would normally get into bed by ten-thirty on a Sunday night and read for fifteen to twenty minutes, something soothing like catalogs or a travel book about the Greek Islands or New Zealand. It was not that she intended to take an expensive or extensive vacation anytime soon, but someday surely she and Marta and Jim too would go off and see some of these places together. She had abandoned her earlier dreams of traveling with her daughters. Elena would not willingly go down to the corner deli with her, and Rachel was keeping kosher now, which made cooking for her less than fun. Kosher vegetarian: one of the world’s lumpier cuisines. Rachel never talked about going anyplace abroad now except Israel.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Tonight Suzanne was overexcited. She was yeasty with hope she labeled irrational that perhaps she and Elena could actually get along, could reach some breakthrough in communication, in affection. It was a new chance. She had never expected Elena to live under her roof again. Yet now Elena’s sounds seeped through the wall. Moving furniture? Pounding nails? The sound of salsa through the wall. She had overcome her earlier stupid sense of being invaded. Wouldn’t Jake be jealous of her, not only in contact with her daughter but once again living with her? She should appreciate what she had, instead of sulking about her privacy and her routine. She was lucky to have her daughter with her, and she should dedicate some of her energy to making things better between them. Still she had her policewoman to worry about, the sexual harassment case against the Dedham Police Department. She wanted very badly to win this case, for her client Sherry, and because if she won, it would set a precedent in the area, letting many other women who had been treated just as badly come slowly out of their private hells and begin to demand justice and reparation. The Latino music came ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("through the wall to her where she lay wide awake in her bed, and she found herself nodding to the beat.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She suddenly thought of Victor, his lean body, his olive face with the sculptured cheekbones and the sensual mouth, and even after all the troubles and all the years, something moved deep down in her. How she had been mad for him. Besotted. When he touched her, her bones liquefied. Her brain turned off like a computer whose plug had been pulled. They made love mostly in Spanish, besides the universal language of their bodies. How could she have loved him so strongly? But she had. He was not her first lover, but he was the most potent male force that had ever entered her life. He had left her pregnant, shaken, and mistrustful of the power and danger passion held for her. He had taught her how easily she could be rendered foolish, passive, all the things she despised; how easily she could be hurt. That was twenty-seven years ago, and still she shuddered. She had learned after that adventure how to protect herself from the possibility of subjection, her defenselessness before her own body’s desire. If only Elena could learn the same at a smaller cost. She had bequeathed to her daughter her terrible vulnerability, but not the lacquered shell she had grown to protect it.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d5935c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006-chapter02.vue
// module id = 72
// module chunks = 0